import { SocialMediaNetwork } from '@professocial/professocialTypes/types/commonTypes'
import { PostingError, Restrictions, PostingErrorCode } from '../shared/types/types'
import { NetworkType } from '@3m5/sm_publish-frontend-api'

const fileSize = (imageBaseString: string) => {
  const suffix = 1 // y will be 2 if Base64 ends with '==' and 1 if Base64 ends with '='.
  const imageSize = imageBaseString.length
  // /8bit > byte
  return Math.floor((imageSize * (3 / 4) / 8) - suffix)
}

const checkFileSize = (img: string, width: number, height: number, socialMediaNetwork: SocialMediaNetwork, restrictions: Restrictions) => {
  const fileSizeCalc = fileSize(img)
  const error: PostingError[] = []

  // todo video noch prüfen
  Object.keys(socialMediaNetwork).map((network:string) => {
    let networkType: NetworkType = NetworkType.Facebook
    if (network === 'instagram') {
      networkType = NetworkType.Instagram
    }
    if (network === 'googleMyBusiness') {
      networkType = NetworkType.GoogleMyBusiness
    }
    if (socialMediaNetwork[network] && restrictions[network]) {
      // filesize restrictions[network].image.maxFileSizeInBytes
      const maxFileSizeInBytes: number | undefined = restrictions[network].image?.maxFileSizeInBytes

      if (maxFileSizeInBytes && fileSizeCalc >= maxFileSizeInBytes) {
        error.push({
          errorCode: PostingErrorCode.errorImageTooLarge,
          network: networkType,
        })
      }
    }
  })

  return error
}

export default checkFileSize
